import React, { ReactNode } from 'react';
import { MsalProvider as MSALProvider } from '@azure/msal-react';
import { msalInstance } from './msalConfig';

interface MsalProviderProps {
  children: ReactNode;
}

export const MsalProvider = ({ children }: MsalProviderProps) => {
  return <MSALProvider instance={msalInstance}>{children}</MSALProvider>;
};
